import { render, staticRenderFns } from "./jobRiskHazardPicture.vue?vue&type=template&id=f5b8dfd0"
import script from "./jobRiskHazardPicture.vue?vue&type=script&lang=js"
export * from "./jobRiskHazardPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5b8dfd0')) {
      api.createRecord('f5b8dfd0', component.options)
    } else {
      api.reload('f5b8dfd0', component.options)
    }
    module.hot.accept("./jobRiskHazardPicture.vue?vue&type=template&id=f5b8dfd0", function () {
      api.rerender('f5b8dfd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/pim/jobRiskHazardPicture.vue"
export default component.exports